module.exports = __webpack_public_path__ + "static/img/campaign.3da89bcc.jpg";